import React, { useEffect } from 'react';
import { performanceMonitor } from '../utils/performance';
import { getCLS, getFID, getFCP, getLCP, getTTFB } from 'web-vitals';

const PerformanceMonitor = () => {
  useEffect(() => {
    const measureWebVitals = () => {
      getCLS((metric) => {
        if (window.gtag) {
          window.gtag('event', 'web_vitals', { event_category: 'Performance', event_label: 'CLS', value: Math.round(metric.value * 1000) });
        }
      });
      getFID((metric) => {
        if (window.gtag) {
          window.gtag('event', 'web_vitals', { event_category: 'Performance', event_label: 'FID', value: Math.round(metric.value) });
        }
      });
      getFCP((metric) => {
        if (window.gtag) {
          window.gtag('event', 'web_vitals', { event_category: 'Performance', event_label: 'FCP', value: Math.round(metric.value) });
        }
      });
      getLCP((metric) => {
        if (window.gtag) {
          window.gtag('event', 'web_vitals', { event_category: 'Performance', event_label: 'LCP', value: Math.round(metric.value) });
        }
      });
      getTTFB((metric) => {
        if (window.gtag) {
          window.gtag('event', 'web_vitals', { event_category: 'Performance', event_label: 'TTFB', value: Math.round(metric.value) });
        }
      });
    };

    const measureMemory = () => {};

    // Defer all monitoring to idle so it doesn't add to TBT during initial load
    const runWhenIdle = window.requestIdleCallback || ((cb) => setTimeout(cb, 1));
    let memoryInterval;
    runWhenIdle(() => {
      measureWebVitals();
      memoryInterval = setInterval(measureMemory, 120000);
    });
    return () => {
      if (memoryInterval) clearInterval(memoryInterval);
    };
  }, []);

  // Don't render anything
  return null;
};

export default PerformanceMonitor;
